import React from "react";

export const EyeClosedIcon = ({
  props,
  height,
  width,
}: {
  props?: React.SVGProps<SVGSVGElement>;
  height?: string;
  width?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "17"}
      height={height || "8"}
      viewBox="0 0 17 8"
      fill="none"
      {...props}
    >
      <path
        d="M15.0957 0.25C15.2682 -0.00791451 15.6167 -0.0774406 15.875 0.0947266C16.1334 0.267004 16.2034 0.615559 16.0312 0.874023L16.0283 0.878906C15.9998 0.919669 15.9244 1.0269 15.8779 1.08984C15.7813 1.22078 15.6396 1.40576 15.4561 1.62598C15.2334 1.89318 14.9442 2.211 14.6006 2.55371L15.9609 3.91406C16.1806 4.13373 16.1806 4.49029 15.9609 4.70996C15.7413 4.92963 15.3847 4.92963 15.165 4.70996L13.7725 3.31738C13.0545 3.9209 12.1674 4.52908 11.1387 4.96973L11.9209 6.27344C12.0803 6.53976 11.9938 6.88518 11.7275 7.04492C11.4612 7.20458 11.1158 7.11788 10.9561 6.85156L10.0547 5.34961C9.43016 5.52099 8.76538 5.62498 8.06348 5.625C7.3613 5.625 6.69603 5.5211 6.07129 5.34961L5.1709 6.85156C5.01107 7.11795 4.66483 7.20476 4.39844 7.04492C4.13233 6.88509 4.04652 6.53971 4.20605 6.27344L4.9873 4.96973C3.95838 4.52891 3.07057 3.92105 2.35254 3.31738L0.960938 4.70996C0.741268 4.92963 0.384709 4.92963 0.165039 4.70996C-0.0543909 4.49027 -0.0545508 4.13365 0.165039 3.91406L1.52441 2.55371C1.18101 2.21117 0.892478 1.89304 0.669922 1.62598C0.490185 1.41029 0.204199 1.02188 0.101562 0.882812L0.0957031 0.874023C-0.0765253 0.615668 -0.00719018 0.267137 0.250977 0.0947266C0.509316 -0.0774995 0.858824 -0.0081265 1.03125 0.25C1.11635 0.365294 1.3663 0.703801 1.53418 0.905273C1.87073 1.30914 2.36518 1.84733 2.99219 2.38477C4.25511 3.46727 6.00355 4.5 8.06348 4.5C10.1233 4.49993 11.8719 3.46723 13.1348 2.38477C13.7616 1.84744 14.2553 1.30908 14.5918 0.905273C14.7598 0.703711 15.0107 0.365145 15.0957 0.25Z"
        fill="#111827"
      />
    </svg>
  );
};
